import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-daily-ah-fleet-utilization',
	templateUrl: './daily-ah-fleet-utilization.component.html',
	styleUrls: ['./daily-ah-fleet-utilization.component.css']
})
export class DailyAhFleetUtilizationComponent {

	@Input() toDate = new Date();
	@Input() fromDate = new Date(this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
	@Input() selectedTruckType = "All";
	@Input() selectedTruckManufacturer = "All";
	@Output() prepareParentFiltersOptions = new EventEmitter<{ truckTypes: any[], truckManufacturers: any[] }>(); chartType = 'ah';

	chart = {
		firstChartTitle: this.translate.instant('utilization.daily_ahr_fleet_utilization'),
		secondChartTitle: this.translate.instant('utilization.daily_percetn_ahr_fleet_utilization'),
		firstChartYAxeTitle: this.translate.instant('g.ahr'),
	}
	devicesType = [DeviceFactory.types.iotah];

	constructor(
		private translate: TranslateService
	) {}

	onPrepareParentFiltersOptions(event: { truckTypes: any[], truckManufacturers: any[] }) {
		this.prepareParentFiltersOptions.emit({ truckTypes: event.truckTypes, truckManufacturers: event.truckManufacturers });
	}
}
